import { useState } from 'react';
import { nhlHeadshotUrl } from '../../shared/player-media';

type PlayerAvatarProps = {
  firstName: string;
  lastName: string;
  displayName?: string | null;
  nhlId?: number | null;
  imageUrl?: string | null;
  mediaChecked?: boolean;
  className?: string;
};

export function PlayerAvatar({
  firstName,
  lastName,
  displayName,
  nhlId,
  imageUrl: providedImageUrl,
  mediaChecked = false,
  className = 'h-11 w-11 rounded-full',
}: PlayerAvatarProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const imageUrl = providedImageUrl ?? (mediaChecked ? null : nhlHeadshotUrl(nhlId));
  const initials = `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
  const showImage = Boolean(imageUrl && imageUrl !== failedUrl);

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden bg-bartlett/10 font-mono text-[12px] font-semibold text-bartlett ring-1 ring-border ${className}`}
      title={showImage ? `${displayName ?? `${firstName} ${lastName}`} · NHL photo` : undefined}
    >
      {imageUrl && showImage ? (
        <img
          src={imageUrl}
          alt=""
          loading="lazy"
          className="h-full w-full object-cover"
          onError={() => setFailedUrl(imageUrl)}
        />
      ) : (
        <span aria-hidden="true">{initials}</span>
      )}
    </div>
  );
}
